import axios from 'axios'
import { useEffect, useMemo, useState } from 'react'
import { Link } from 'react-router-dom'
import { useRecoilState, useRecoilValue } from 'recoil'
import { FaBook, FaChevronRight } from "react-icons/fa";

import bannerLimeAluno from '../../assets/images/banner-lime-aluno.jpg'
import bannerLimeGestor from '../../assets/images/banner-lime-gestor.jpg'
import bannerLimeProfessor from '../../assets/images/banner-lime-professor.jpg'
import bannerSerGoias from '../../assets/images/banner-ser-goias.png'
import bannerSUAE from '../../assets/images/banner-ouvir-acolher.png'
import bannerGoEnglish from '../../assets/images/banner-goenglish.png'
import bannerGoiasTec from '../../assets/images/banner-goias-tec.png'
import bannerFic from '../../assets/images/banner-fic.png'
import bannerEjaTec from '../../assets/images/banner-eja-tec.png'
import bannerProfissionaliza from '../../assets/images/banner-profissionaliza.png'
import bannerGuiaIA from '../../assets/images/banner-guia-ia.png'
import bannerConectando from '../../assets/images/banner-conectando.png'
import bannerEnem2025 from '../../assets/images/banner-enem2025.jpg'
import bannerProgramaBolsaEstudo from '../../assets/images/banner-programa-bolsa-estudo.png'
import bannerBrabo from '../../assets/images/banner-brabo.png'
import bannerSaeb from '../../assets/images/banner-saeb.png'
import bannerPensamentoComputacional from '../../assets/images/banner-PensamentoComputacional.jpeg'
import bannerDesafioCrescer6ao9 from '../../assets/images/banner-desafio-crescer-6ao9.png'
import bannerDesafioCrescer2 from '../../assets/images/banner-desafio-crescer-2serie.png'
import bannerIfaEnem from '../../assets/images/banner-ifa-enem.png'
import bannerIfaIntegrador from '../../assets/images/banner-ifa-integrador.png'
import bannerEnem from '../../assets/images/banner-enem.png'
import bannerLaboratorioAcao from '../../assets/images/banner-LaboratorioAcao.png'
import bannerEnsinoMedioSenai from '../../assets/images/banner-em-senai.png'
import bannerQualificacaoProfissional from '../../assets/images/banner-qualificacao-profissional.png'
import bannerRevisaGoias from '../../assets/images/banner-revisa-goias.png'

//import focaChromebook from '../../assets/images/foca-chromebook.png'
import bannerCEPI from '../../assets/images/banner-meuCEPI.png'
import bannerDenunciaBullying from '../../assets/images/Banner-Disque-Bullying.png'
import bannerGuiaChromebook from '../../assets/images/banner-guia-chromebook.png'

import guiaIaPdf from '../../assets/images/GUIA_PARA_USO_DA_IA.pdf'
import guiaChromebook from '../../assets/images/GUIA_PARA_USO_CHROMEBOOK.pdf'
import focaChromebook from '../../assets/images/Doris.png'
import mascoteEnem from '../../assets/images/mascote-enem.png'

import Modal from '../../components/DataDisplay/Modal/Modal'
import ModalBolsaEstudo from '../../components/DataDisplay/ModalBolsaEstudo/ModalBolsaEstudo'
import Footer from '../../components/layout/Footer/Footer'
import { Col, Container, Row } from '../../components/layout/Grid/Grid'
import Header from '../../components/layout/Header/Header'
import { TabsSection } from '../../components/layout/TabsSection/TabsSection'
import { UserType } from '../../domain/enuns/UserType.enum'
import { limeSurvey } from '../../services/limeSurvey'
import themeState from '../../store/themeAtom'
import UserState from '../../store/UserAtom'
import { ResponseFormularioEnem } from '../../domain/entities/EnemForm'
import {
  CardsContent,
  FlexContainer,
  IllustrationContainer ,
  LinksWrapper,
  MainSection,
  PresentationText,
  MaterialContainer,
  IconCircle,
  TextContent,
  ButtonAcessar,
} from './styles'
import { ButtonWrapper } from '../Contact/style'
import api from '../../services/api'
import { ResponseDatasEnem } from '../../domain/entities/EnemForm'
import BannerGrid from '../../components/BannerGrid/BannerGrid'
import LinkButton from '../../components/navigation/LinkButton/LinkButton'
import { CountdownEnem } from '../../components/CountdownEnem/CountdownEnem'
import { useHistory } from 'react-router-dom';
import { UserRole } from '../../domain/enuns/UserRole';

const typeBanner = {
  [UserType.student]: bannerLimeAluno,
  [UserType.teacher]: bannerLimeProfessor,
  [UserType.manager]: bannerLimeGestor,
}

function Home({ history }: any) {
  const user = useRecoilValue(UserState)
  const [theme, setTheme] = useRecoilState(themeState)
  const [showModalBolsaEstudo] = useState(false)
  const [controlLimeModal, setControlLimeModal] = useState({
    show: false,
    url: '',
    token: '',
    tipoUsuario: UserType.student,
  })

  const codigoComposicaoEnem = new Set([
    '141', '153', '154', '160', '521', '530', '531', '536', '539',
    '553', '557', '558', '559', '560', '571', '572', '573', '615', '621'
  ]);

  const codigosSeriesAnoTerminarios: string[] = [
    '1413',
    '1533',
    '1543',
    '1603',
    '4433',
    '4434',
    '5213',
    '5303',
    '5313',
    '5344',
    '5353',
    '5363',
    '5393',
    '5463',
    '5513',
    '5533',
    '5573',
    '5583',
    '5593',
    '5603',
  ];

  const codigosSeriesSAUE: string[] = [
    '1996',
    '1997',
    '1998',
    '1999',
    '1411',
    '1412',
    '1413',
  ];

  const funcoesPermitidasMateriais: string[] = [
    '172', '173', '305', '361', '363', '556', '627', '628', '715','738', '748'
  ]

  const showMenuEnem = useMemo(() => {
    return (
      !!user &&
      user.matricula &&
      codigosSeriesAnoTerminarios.includes(user.codigoSerie) &&
      (user.codigoNivelEnsino == 3 || user.codigoNivelEnsino == 4) &&
      user.respondeuFormularioEnem !== 1
    )
  }, [user])

  const linksSimulado: Record<string, string> = {
    '5º Ano': 'https://forms.gle/vxzqyijf4WskTvDUA',
    '9º Ano': 'https://forms.gle/RMd7Vf9LtGKBurLg8',
    '3º Ano': 'https://forms.gle/1tPnmec71ze4imMh9',
    '3ª Série': 'https://forms.gle/1tPnmec71ze4imMh9',
  }

  const currentDate = new Date()
  const currentYear = currentDate.getMonth() >= 9 ? currentDate.getFullYear() : currentDate.getFullYear() - 1
  const [_, setIniciouFormularioEnem] = useState<boolean>(false)
  const [acessaSerGoias, setAcessaSerGoias] = useState<boolean>(false)
  const [modalEnemVisivel, setModalEnemVisivel] = useState<boolean>(false)
  const [datasFormularioEnem, setDatasFormularioEnem] = useState<ResponseDatasEnem>({} as ResponseDatasEnem)
  const [datasEnem, setDatasEnem] = useState<ResponseDatasEnem>({} as ResponseDatasEnem)
  const [mensagemModalEnemPt1, setMensagemModalEnemPt1] = useState<string>('')
  const [mensagemModalEnemPt2, setMensagemModalEnemPt2] = useState<string>('')
  const [periodoParticipacao, setPeriodoParticipacao] = useState<boolean>(false)
  const [periodoNotas, setPeriodoNotas] = useState<boolean>(false)
  const [periodoSisu, setPeriodoSisu] = useState<boolean>(false)
  const [acessaSAUE, setAcessaSAUE] = useState<boolean>(false)
  const [acessaGoEnglish, setAcessaGoEnglish] = useState<boolean>(false)
  const [exibeBannerEnem, setExibeBannerEnem] = useState<boolean>(false)
  const [exibeBannerVemEnem, setExibeBannerVemEnem] = useState<boolean>(false)
  const [exibeBannerCrescerFund, setExibeBannerCrescerFund] = useState<boolean>(false)
  const [exibeBannerCrescerMedio, setExibeBannerCrescerMedio] = useState<boolean>(false)
  const [exibeBannerPrimeiraSerie, setExibeBannerPrimeiraSerie] = useState<boolean>(false)
  const [exibeBannerEnsinoMedioSenai, setExibeBannerEnsinoMedioSenai] = useState<boolean>(false)
  const [exibeBannerPosMedio, setExibeBannerPosMedio] = useState<boolean>(false)
  const [exibeBannerQualificacao, setExibeBannerQualificacao] = useState<boolean>(false)

  const [exibeBannerPensamentoComputacional, setExibeBannerPensamentoComputacional] = useState<boolean>(false)
  const [exibeMensagemEnem, setExibeMensagemEnem] = useState<boolean>(false)

  function SetMensagemModalEnem(formularioEnem: ResponseFormularioEnem) {
    if (
      new Date(datasFormularioEnem.dataInicioParticipacaoPrimeiraFase) <= currentDate &&
      currentDate <= new Date(datasFormularioEnem.dataFimParticipacao)
    ) {
      setPeriodoParticipacao(true)
    }
    if (
      new Date(datasFormularioEnem.dataInicioNotas) <= currentDate &&
      currentDate <= new Date(datasFormularioEnem.dataFimNotas)
    ) {
      setPeriodoNotas(true)
    }
    if (
      new Date(datasFormularioEnem.dataInicioSisu) <= currentDate &&
      currentDate <= new Date(datasFormularioEnem.dataFimSisu)
    ) {
      setPeriodoSisu(true)
    }

    if (!codigosSeriesAnoTerminarios.includes(user.codigoSerie)) {
      setMensagemModalEnemPt1('')
      setMensagemModalEnemPt1('')
      setModalEnemVisivel(false)
      return
    }
    if (showMenuEnem && (periodoParticipacao || periodoNotas || periodoSisu)) {
      if (
        periodoSisu &&
        (formularioEnem?.primeiraFase == false ||
          formularioEnem?.segundaFase == false ||
          formularioEnem?.notaRedacao == null)
      ) {
        setModalEnemVisivel(false)
        return
      }
      if (
        (periodoParticipacao && formularioEnem?.primeiraFase != null && formularioEnem?.segundaFase != null) ||
        (periodoNotas && !Number.isNaN(parseFloat(formularioEnem?.notaRedacao))) ||
        (periodoSisu && formularioEnem?.situacaoEnem != null)
      ) {
        setModalEnemVisivel(false)
        return
      }
    }

    if (periodoParticipacao) {
      setMensagemModalEnemPt1('Sabemos que você está inscrito no Exame Nacional do Ensino Médio - ENEM.')
      setMensagemModalEnemPt2('Conte-nos sobre a sua participação no 1° e 2° dias. Segue o formulário!')
    } else if (periodoNotas) {
      setMensagemModalEnemPt1('Você participou do Exame Nacional do Ensino Médio - ENEM. Vamos saber de suas notas?')
      setMensagemModalEnemPt2(
        'Gostaríamos que você participasse do formulário a seguir para sabermos mais sobre o seu desempenho!',
      )
    } else if (periodoSisu) {
      setMensagemModalEnemPt1('Parabéns pela sua participação no ENEM!')
      setMensagemModalEnemPt2(
        'Gostaríamos que nos contasse se você foi aprovado para ingressar em alguma instituição de Ensino Superior. Para isso, pedimos que preencha o formulário a seguir.',
      )
    }
    if (mensagemModalEnemPt1.length > 0 && mensagemModalEnemPt2.length > 0) {
      setModalEnemVisivel(true)
    }
  }

  useEffect(() => {
    (async () => {
      if (user?.tipoUsuario != 1) {
        setAcessaSAUE(true);
      }
      else if (user?.codigoSubsecretaria == '134' || user?.codigoSubsecretaria == '140') {
        if (codigosSeriesSAUE.includes(user?.codigoSerie)) {
          setAcessaSAUE(true);
        }
      }
    })()
  }, [user]);

  useEffect(() => {
    (() => {
      const codNivelEnsino = 3; // Ensino Médio
      const seriesPermitidas: string[] = [
        '1411',
        '1412',
        '1413',
      ];

      const dataAtual = new Date();
      const dataLimite = new Date(2025, 5, 7); // 06/06/2025

      if ((seriesPermitidas.includes(user?.codigoSerie) || user?.codigoNivelEnsino === codNivelEnsino) && dataAtual < dataLimite) {
        setExibeBannerEnem(true);
      }
    })();
  }, [user]);

  useEffect(() => {
    (() => {
      const seriesPermitidas: string[] = [
        '1999', '5184', '5564', '6224', '6354',
      ]; // 9º Ano

      if (seriesPermitidas.includes(user?.codigoSerie) || user?.tipoUsuario != 1) {
        setExibeBannerPensamentoComputacional(true);
      }
    })();
  }, [user]);

  useEffect(() => {
    (() => {
      const seriesPermitidas: string[] = [
        '1996', '1997', '1998', '1999', '5181', '5182', '5183', '5184', '5232', '5233', '5266', '5276', '5412', '5413', 
        '5432', '5433', '5561', '5562', '5563', '5564', '6221', '6222', '6223', '6224', '6351', '6352', '6354',
      ]; // 6º ao 9º Ano todas as composições

      if (seriesPermitidas.includes(user?.codigoSerie) || user?.tipoUsuario != 1) {
        setExibeBannerCrescerFund(true);
      }
    })();
  }, [user]);

  useEffect(() => {
    (() => {
      const seriesPermitidas: string[] = [
      '1141', '1361', '1401', '1411', '1421', '1441', '1491', '1571', '1591', '1611', '1621', '1901', '1911', '1921', '2001', '5211', '5311', '5341', 
      '5351', '5391', '5461', '5481', '5491', '5501', '5511', '5521', '5531', '5551', '5571', '5581', '5591', '5601', '5611', '5621', '5631', '5641', 
      '5651', '5661', '5671', '5681', '5691', '5701', '5711', '5741', '5771', '5781', '5791', '5801', '5811', '5821', '5831', '5841', '5851', '5861', 
      '5871', '5881', '5891', '5901', '5911', '5921', '5931', '5941', '5951', '5961', '5971', '5981', '5991', '6001', '6011', '6021', '6031', '6041', 
      '6051', '6161', '6191', '6201', '6211', '6231', '6251', '6261', '6271', '6281', '6291', '6301', '6311', '6321', '6331', '6361', '6371', '6381',
      ]; // 1º Série todas as composições

      if (seriesPermitidas.includes(user?.codigoSerie) || user?.tipoUsuario != 1) {
        setExibeBannerPrimeiraSerie(true);
      }
    })();
  }, [user]);

  useEffect(() => {
    (() => {
      const seriesPermitidas: string[] = [
        '1142', '1362', '1402', '1412', '1422', '1442', '1492', '1572', '1592', '1612', '1622', '1902', '1912', '1922', '2002', '5212', '5312', '5342',
        '5352', '5392', '5462', '5482', '5492', '5502', '5512', '5522', '5532', '5552', '5572', '5582', '5592', '5602', '5612', '5622', '5632', '5642', 
        '5652', '5662', '5672', '5682', '5692', '5702', '5712', '5742', '5772', '5782', '5792', '5802', '5812', '5822', '5832', '5842', '5852', '5862', 
        '5872', '5882', '5892', '5902', '5912', '5922', '5932', '5942', '5952', '5962', '5972', '5982', '5992', '6002', '6012', '6022', '6032', '6042', 
        '6052', '6162', '6192', '6202', '6212', '6232', '6252', '6262', '6272', '6282', '6292', '6302', '6312', '6322', '6332', '6362', '6372', '6382',
      ]; // 2° Série todas as composições

      if (seriesPermitidas.includes(user?.codigoSerie) || user?.tipoUsuario != 1) {
        setExibeBannerCrescerMedio(true);
      }
    })();
  }, [user]);

  useEffect(() => {
    (() => {
      const seriesPermitidas: string[] = [
        '1363', '1403', '1413', '1423', '1443', '1493', '1573', '1593', '1613', '1623', '1903', '1913', '1923', '2003', '5213', '5313', '5343', '5353', 
        '5393', '5463', '5483', '5493', '5503', '5513', '5523', '5533', '5553', '5573', '5583', '5593', '5603', '5613', '5623', '5633', '5643', '5653', 
        '5663', '5673', '5683', '5693', '5703', '5713', '5743', '5773', '5783', '5793', '5803', '5813', '5823', '5833', '5843', '5853', '5863', '5873', 
        '5883', '5893', '5903', '5913', '5923', '5933', '5943', '5953', '5963', '5973', '5983', '5993', '6003', '6013', '6023', '6033', '6043', '6053', 
        '6163', '6193', '6203', '6213', '6233', '6253', '6263', '6273', '6283', '6293', '6303', '6313', '6323', '6333', '6363', '6373', '6383',
      ]; // 3º Série todas as composições

      if (seriesPermitidas.includes(user?.codigoSerie) || user?.tipoUsuario != 1) {
        setExibeBannerVemEnem(true);
      }
    })();
  }, [user]);

  useEffect(() => {
    (() => {
      const serieGoiasTecPermitida = '5391'; // 1º serie do Goiás Tec
    
      const seriesPermitidas: string[] = [
        '1411'
      ]; 

      const turnoPermitido = 3; // Noturno

      if (serieGoiasTecPermitida == user?.codigoSerie || (seriesPermitidas.includes(user?.codigoSerie) && user?.turno == turnoPermitido) || user?.tipoUsuario != 1) {
        setExibeBannerEnsinoMedioSenai(true);
      }
    })();
  }, [user]);

  useEffect(() => {
    (() => {
      let seriesPermitidas: string[] = [
        '1999',
        '1411',
        '1412',
        '1413',
      ];

      if (user?.tipoUsuario != 1) {
        setAcessaGoEnglish(true);
      }
      else if (seriesPermitidas.includes(user?.codigoSerie)) {
        setAcessaGoEnglish(true);
      }
    })()
  }, [user]);

  useEffect(() => {
    (() => {
      // Caracteristicas de escola que indicam turno integral
      const caracteristicasPermitidas: number[] = [15, 12, 10, 13, 14, 8]
      // Alunos de ensino médio em turmas ou escolas de turno integral
      if ((user?.codigoNivelEnsino == 3 && user?.turno == 4) || (user?.codigoNivelEnsino == 3 && caracteristicasPermitidas.includes(user?.caracteristicaEscola)) || user?.tipoUsuario != 1) {
        setExibeBannerPosMedio(true);
      }
    })();
  }, [user]);

  useEffect(() => {
    (() => {
      // 1º serie de EJA 3° etapa
      const seriesPermitidas: string[] = [
        '5721', '6411'
      ]

      if (seriesPermitidas.includes(user?.codigoSerie) || user?.tipoUsuario != 1) {
        setExibeBannerQualificacao(true);
      }
    })();
  }, [user]);

  useEffect(() => {
    (async () => {
      const data = await api.get(`${process.env.REACT_APP_LOGIN_API}/enem/DatasFormulario/${currentYear}`)
      if (!data.data) return

      setDatasFormularioEnem(data.data)
      setDatasEnem(data.data)
    })()
  }, []);
  
  useEffect(() => {
    (async () => {
      const data = await api.get(`${process.env.REACT_APP_LOGIN_API}/enem/DatasFormulario/${currentYear+1}`)
      if (!data.data) return
      
      setDatasEnem(data.data)
    })()
  }, []);

  useEffect(() => {
    ;(async () => {
      if (user?.matricula != null) {
        const dataFormulario = await api.get(
          `${process.env.REACT_APP_LOGIN_API}/enem/FomarularioEnem/${user?.matricula}/${currentYear}`,
        )
        SetMensagemModalEnem(dataFormulario.data)
        if (dataFormulario.data == null) {
          setIniciouFormularioEnem(false)
          return
        } else {
          setIniciouFormularioEnem(true)
          return
        }
      }
    })()
  })

  useEffect(() => {
    (async () => {
      if (user) {
        const escolas = await api.get(`${process.env.REACT_APP_LOGIN_API}/escola/EscolasPermitidas`);
        if (!escolas.data?.some((escola: { codigoMec: number }) => escola.codigoMec == user?.codigoEscola)) {
          setAcessaSerGoias(true);
        }
      }
    })()
  }, [user])

  useEffect(() => {
    if (user?.codigoSerie == 1413 && currentDate <= new Date('2025-11-19T23:59:59')) {
      setExibeMensagemEnem(true)
    }
  }, [user])

    useEffect(() => {
    if (user) {
      const activeTheme = showMenuEnem ? 'home_enem' : 'home'
      setTheme(activeTheme)
    }
  }, [user])

  useEffect(() => {
    ;(async () => {
      if (user?.token && user?.matricula) {
        const response = await axios.post(`${process.env.REACT_APP_LOGIN_API}/user/GetAlunoByToken`, {
          token: user.token,
        })
        const userData = response.data
        if (userData == null) {
          localStorage.removeItem('netescola')
          history.push('/login')
        }
      }
    })()
  }, [user])

  useEffect(() => {
    const getLimeControls = async () => {
      const limeControls = await limeSurvey(user)

      if (limeControls) {
        setControlLimeModal({ ...limeControls, show: limeControls.questionarioLimesurvey })
      }
    }
    user && getLimeControls()
  }, [user])

  const codigoComposicao = user?.codigoSerie?.slice(0, 3);

  const editoraDcHref = (() => {
    if (!process.env.REACT_APP_EDITORA_DC) {
      return `https://editoradc.redu.digital/net-escola-error`
    }

    try {
      const editoraDcUrl = new URL(process.env.REACT_APP_EDITORA_DC)
      editoraDcUrl.searchParams.set('token', user.authToken)
      editoraDcUrl.searchParams.set('matricula', user?.matricula ?? '')
      return editoraDcUrl.toString()
    } catch {
      return `https://editoradc.redu.digital/net-escola-error`
    }
  })();

  const handleBannerClick = async (codigoBanner?: string) => {
    if (!codigoBanner || !user?.authToken) {
      return
    }

    const tipoUsuario = user?.tipoUsuario?.[0]
    const login = user?.matricula ?? user?.office

    const evento = {
  tipo: tipoUsuario === 1
    ? UserRole.student
    : tipoUsuario === 2
      ? UserRole.teacher
      : undefined,

      login,
      codigoBanner
    }

    try {
      const url = `${process.env.REACT_APP_API}/Portal/RegistreLogCliqueBanner`
      await api.post(url, evento)
    } catch (error) {
      console.error("Erro ao registrar clique no banner.", error)
    }
  }

  return (
    <>
      <Modal show={controlLimeModal.show} link={controlLimeModal.url && `${controlLimeModal.url}`}>
        <img src={typeBanner[controlLimeModal.tipoUsuario]} alt="banner lime" />
      </Modal>
      {modalEnemVisivel && (
        <Modal key="modalEnem" show={modalEnemVisivel}>
          Caro(a) estudante {user?.nome}!
          <br /> <br />
          <p>{mensagemModalEnemPt1}</p> <br />
          <p>{mensagemModalEnemPt2}</p> <br />
          <ButtonWrapper>
            <Link to="/notas-enem" style={{ color: 'blue' }}>
              <u>RESPONDER FORMULÁRIO ENEM</u>
            </Link>
          </ButtonWrapper>
        </Modal>
      )}
      <ModalBolsaEstudo show={showModalBolsaEstudo} />
      <Header />
      <MainSection>
        <Container>
          <Row align="center">
            <Col>
              <FlexContainer>
                {exibeMensagemEnem
                  ? (
                    <PresentationText>
                      Queridos estudantes da rede estadual,<br/><br/>
                      Chegou o grande dia: a primeira etapa do ENEM! 🌟<br/>
                      Vocês se prepararam, se dedicaram e agora é o momento de acreditar em todo o esforço feito até aqui.<br/>
                      Saibam que toda a equipe da Secretaria de Educação de Goiás está torcendo por cada um de vocês.
                      O ENEM é mais do que uma prova — é uma porta de entrada para novas conquistas, para os sonhos que vocês vêm construindo ao longo dessa caminhada.<br/>
                      Confiem no que aprenderam, mantenham a calma e façam a prova com tranquilidade. Vocês não estão sozinhos:
                      Goiás inteiro acredita no talento e no futuro brilhante de cada estudante da nossa rede.<br/>
                      Desejo boa sorte e muito sucesso a todos! 🍀✨<br/><br/>
                      Com carinho e orgulho,<br/>
                      Professora Fátima Gavioli e Governador Ronaldo Caiado.
                    </PresentationText>
                  )
                  : (
                    <PresentationText>
                      Olá, sou Doris,  a foca! Bem-vindo ao NetEscola, o ambiente de aprendizagem digital oficial da Secretaria de Estado da Educação de Goiás.
                      Aqui, você encontra tudo o que precisa para aprender e se preparar para o futuro! 
                      Acesse videoaulas,  atividades, listas de exercícios, simulados, quizzes e vários materiais exclusivos produzidos por nossos professores, tudo em um só lugar e feito para você!
                      Agora ficou muito mais fácil estudar, revisar e tirar dúvidas de onde você estiver. 🚀
                      👉Marque sua série, explore o que está disponível para você e comece sua jornada de estudos hoje mesmo! 
                      Estamos juntos nessa! FOCA NO NETESCOLA!
                    </PresentationText>
                  )
                }
                <br/>
                {((codigoComposicao && codigoComposicaoEnem.has(codigoComposicao)) || (user?.tipoUsuario?.[0] === 2)) && (
                  <CountdownEnem datasEnem={datasEnem} />
                )}
              </FlexContainer>
              <LinksWrapper>
                <LinkButton
                  bgcolor={'#ffa500'}
                  text="Material Didático - Goiás Tec"
                  textcolor="#fff"
                  fontSize="14px"
                  href={(user?.tipoUsuario[0] === 2 && user?.docenciaServidor?.length !== 0) ? "https://drive.google.com/drive/u/1/folders/1zjKSqu00XG4KC8ck9KAYHtWvGZpOUA1G" : "https://drive.google.com/drive/u/0/folders/1M-MjHKCtGeQJ4pECSSIvpiqC5Zms1_-X"}
                  target="_blank"
                />
                <LinkButton
                  bgcolor={'#ee58e1'}
                  text="Letrus Professor"
                  textcolor="#fff"
                  href="https://professor.letrus.com.br/login"
                  target="_blank"
                />
                <LinkButton
                  bgcolor={'#56b417'}
                  text="Portal Educa"
                  textcolor="#fff"
                  href="https://portaleduca.educacao.go.gov.br"
                  target="_blank"
                />
                <LinkButton
                  bgcolor={'#658dd8'}
                  text="CEPFOR"
                  textcolor="#fff"
                  href="https://escolavirtual.educacao.go.gov.br"
                  target="_blank"
                />
                <LinkButton
                    bgcolor={'#1F8B59'}
                    text="Professor SENAI"
                    textcolor="#fff"
                    href="https://senaigoias.com.br/eadcursos/seduc"
                    target="_blank"
                />
              </LinksWrapper>
            </Col>
            {exibeMensagemEnem
              ? (
                <IllustrationContainer>
                  <img src={mascoteEnem} width='500px'></img>
                </IllustrationContainer>
              )
              : (
                <IllustrationContainer>
                  <img src={focaChromebook} width='340px'></img>
                </IllustrationContainer>
              )
            }
          </Row>
        </Container>
      </MainSection>
      {/* Exibir para professores, servidores administrativos de escolas e administradores  da função*/}
      <Container hidden={!(user?.tipoUsuario?.[0] === 2 && (user?.docenciaServidor?.length !== 0 || (user?.ou?.includes("_ESCOLAS"))) 
                          || (user?.perfis?.some((p: any) => p.id === '1' || p.nome === 'Administrador'))
                          || (user?.funcao && funcoesPermitidasMateriais.includes(user?.funcao)))}>
        <MaterialContainer>
          <IconCircle>
            <FaBook color="#008751" size="35"/>
          </IconCircle>
          
          <TextContent>
            <h2>Materiais Didáticos</h2>
            <p> Acesse materiais pedagógicos organizados para apoiar suas aulas, incluindo conteúdos do <strong>Revisa Goiás</strong>, <strong>Redação Nota 1000</strong> e outros recursos educacionais.</p>
          </TextContent>

          <ButtonAcessar onClick={() => history.push('/materiais')}>
            Acessar Materiais <FaChevronRight size={14} style={{ marginLeft: '10px' }} />
          </ButtonAcessar>
        </MaterialContainer>
      </Container>
      <BannerGrid
        banners={[
          ...(exibeBannerCrescerFund
            ? [{ id: "DESAFIO_CRESCER_6_AO_9_ANO", src: bannerDesafioCrescer6ao9, target: "_blank", href: user?.authToken ? `${process.env.REACT_APP_SAGRES}?token=${user?.authToken}&matricula=${user?.matricula}` : '/login' }]
            : []),
          ...(exibeBannerPensamentoComputacional
            ? [{ id: "PENSAMENTO_COMPUTACIONAL_9_ANO", src: bannerPensamentoComputacional, target: "_blank", href: user?.authToken ? `${process.env.REACT_APP_SAGRES}?token=${user?.authToken}&matricula=${user?.matricula}` : '/login' }]
            : []),
          ...(exibeBannerPrimeiraSerie
            ? [{ id: "IFA_PREPARATORIO_ENEM", src: bannerIfaEnem, target: "_blank", href: user?.authToken ? `${process.env.REACT_APP_SAGRES}?token=${user?.authToken}&matricula=${user?.matricula}` : '/login' }]
            : []),
          ...(exibeBannerPrimeiraSerie
            ? [{ id: "IFA_PROJETO_INTEGRADOR", src: bannerIfaIntegrador, target: "_blank", href: user?.authToken ? `${process.env.REACT_APP_SAGRES}?token=${user?.authToken}&matricula=${user?.matricula}` : '/login' }]
            : []),
          ...(exibeBannerCrescerMedio
            ? [{ id: "DESAFIO_CRESCER_2_SERIE", src: bannerDesafioCrescer2, target: "_blank", href: user?.authToken ? `${process.env.REACT_APP_SAGRES}?token=${user?.authToken}&matricula=${user?.matricula}` : '/login' }]
            : []),
          ...(exibeBannerVemEnem
            ? [{ id: "SO_VEM_ENEM_3_SERIE", src: bannerEnem, target: "_blank", href: user?.authToken ? `${process.env.REACT_APP_SAGRES}?token=${user?.authToken}&matricula=${user?.matricula}` : '/login' }]
            : []),
          ...([{ id: "GOIASTEC", src: bannerGoiasTec, href: '/goias-tec' }]),          
          ...(exibeBannerEnsinoMedioSenai
            ? [{ id: "ITINERARIO_FORMACAO_TECNICA_PROFISSIONAL_IFTP", src: bannerEnsinoMedioSenai, target: "_blank", href: user?.authToken ? `${process.env.REACT_APP_EAD_SENAI}?token=${user?.authToken}&matricula=${user?.matricula}` : '/login' }]
            : []),
          ...(exibeBannerQualificacao
            ? [{ id: "EJA_QUALIFICACAO_PROFISSIONAL", src: bannerQualificacaoProfissional, target: "_blank", href: user?.authToken ? `${process.env.REACT_APP_EAD_SENAI}?token=${user?.authToken}&matricula=${user?.matricula}` : '/login' }]
            : []),
          ...([{ id: "REVISA_GOIAS", src: bannerRevisaGoias, target: "_blank", href: 'https://goias.gov.br/educacao/material-didatico/' }]),
          ...([{ id: "LABORATORIOS_EM_ACAO", src: bannerLaboratorioAcao, target: "_blank", href: 'https://www.youtube.com/@laboratóriosemação' }]),
          ...(acessaGoEnglish
            ? [{ id: "GO_ENGLISH", src: bannerGoEnglish, target: "_blank", href: 'https://goenglish.learn.corporate.ef.com' }]
            : []),
          ...([{ id: "GUIA_USO_IA", src: bannerGuiaIA, target: "_blank", href: guiaIaPdf }]),
          ...(exibeBannerPosMedio
          ? [{ id: "MEU_CEPI_10", src: bannerCEPI, target: "_blank", href: user?.authToken ? editoraDcHref : '/login'}]
          : []),
          ...([{ id: "DENUNCIA_BULLYING", src: bannerDenunciaBullying, target: "_blank", href: `${process.env.REACT_APP_DENUNCIA_ESCOLAR}?token=${user?.authToken}` }]),
          ...([{ id: "PROFISSIONALIZA_GOIAS", src: bannerProfissionaliza, target: "_blank", href: 'https://goias.gov.br/educacao/educacao-profissional-e-tecnologica' }]),
          ...([{ id: "EJATEC", src: bannerEjaTec, target: "_blank", href: 'https://ejaead.educacao.go.gov.br/login/index.php' }]),
          ...([{ id: "FIC", src: bannerFic, target: "_blank", href: 'https://ava.educacao.go.gov.br/login/index.php' }]),
          ...([{ id: "PROGRAMA_CONECTANDO_PALAVRAS", src: bannerConectando, target: "_blank", href: 'https://aluno.letrus.com.br/login' }]),
          ...(acessaSAUE
            ? [{ id: "OUVIR_ACOLHER", src: bannerSUAE, target: "_blank", href: 'https://agireducacao.org.br/' }]
            : []),
          ...([{ id: "GUIA_PEDAGOGICO_CHROMEBOOK", src: bannerGuiaChromebook, target: "_blank", href: guiaChromebook }]),
          ...([{ id: "PROGRAMA_BOLSA_ESTUDO", src: bannerProgramaBolsaEstudo, target: "_blank", href: 'https://goias.gov.br/educacao/programa-bolsa-estudo-sobre-o-programa-2' }]),
        ]}
        onBannerClick={handleBannerClick}
      />
      <CardsContent>
        <Container>
          <TabsSection key="uniqueKey" />
        </Container>
      </CardsContent>
      <Footer />
    </>
  )
}

export default Home